import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail-small",
  "use": "icon-mail-small-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mail-small\">\n    <rect x=\"5\" y=\"7\" width=\"14\" height=\"10\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n    <path d=\"M6 8L10.7196 11.933C11.4613 12.5511 12.5387 12.5511 13.2804 11.933L18 8\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol